import HttpRequest from '../../lib/HttpRequest'

const api = new HttpRequest('users')
const actions = {
  activate ({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.post('activate', { id })
        .then(({ data }) => {
          commit('entity', {
            stateKey: 'users',
            data
          })

          resolve(data)
        })
        .catch(({ response }) => reject(response.data))
    })
  }
}

export default actions
